import React, { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";

// 1. IMPORT YOUR LOCAL IMAGES HERE:
import hero1 from "./Images/1.1.png";
import hero2 from "./Images/1.png";
import hero3 from "./Images/2.png";
import hero4 from "./Images/4.png";
import hero5 from "./Images/5.png";

// 2. PUT THEM IN THIS ARRAY
const HERO_IMAGES = [
  hero1,
  hero2,
  hero3,
  hero4,
  hero5
];

const COURSES = [
  { title: "Nursery Teachers Training",       duration: "1 Year",  students: "2,400+", img: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=400&q=80&fit=crop" },
  { title: "Montessori Teachers Training",    duration: "1 Year", students: "1,800+", img: "https://images.unsplash.com/photo-1546410531-bb4caa6b424d?w=400&q=80&fit=crop" },
  { title: "Primary Teachers Training",       duration: "2 Years",  students: "3,100+", img: "https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=400&q=80&fit=crop" },
  { title: "Diploma in School Administration",duration: "1 Year", students: "980+",   img: "https://images.unsplash.com/photo-1562516155-e0c1ee44059b?w=400&q=80&fit=crop" },
  { title: "Yoga Teachers Training",          duration: "1 Year",  students: "1,200+", img: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=400&q=80&fit=crop" },
];

const STATS = [
  { target: 19,    suffix: "+",  label: "Years of Experience", display: v => v + "+" },
  { target: 15300, suffix: "+",  label: "Students Placed",     display: v => Math.floor(v) + "+" },
  { target: 17244, suffix: "+",  label: "Passed Out Students", display: v => Math.floor(v) + "+" },
  { target: 22035, suffix: "+",  label: "Partner Schools",     display: v => Math.floor(v) + "+" },
];

const MARQUEE_ITEMS = [
  "Nursery Training","Montessori","Primary Training",
  "School Admin","Yoga Training","100% Placement Assistance","19+ Years of Experience",
];

const PLACEMENT_PILLS = [
  "✅ Job Assistance","🏫 20,000+ Partner Schools",
  "🌍 Pan-India Placement","👩‍🏫 19,560+ Alumni",
];

// Animated counter
function CountUp({ target, display }) {
  const [val, setVal]   = useState(1); 
  const ref             = useRef(null);
  const started         = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !started.current) {
        started.current = true;
        const steps = 80;
        const stepTime = 2200 / steps;
        const inc = (target > 1 ? (target - 1) / steps : target / steps); 
        let cur = 1;
        const t = setInterval(() => {
          cur += inc;
          if (cur >= target) { cur = target; clearInterval(t); }
          setVal(Math.round(cur)); 
        }, stepTime);
      }
    }, { threshold: 0.4 });
    obs.observe(el);
    return () => obs.disconnect();
  }, [target]);

  return <span ref={ref}>{display(val)}</span>;
}

export default function AnaBelHero() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % HERO_IMAGES.length);
    }, 4500); 
    return () => clearInterval(timer);
  }, []);

  // SEO: Generate JSON-LD Schema for Google Course Carousel
  const courseSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": COURSES.map((course, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "item": {
        "@type": "Course",
        "name": course.title,
        "description": `${course.title} spanning ${course.duration}. Join over ${course.students} enrolled students.`,
        "provider": {
          "@type": "EducationalOrganization",
          "name": "AnaBel Institute",
          "sameAs": "https://www.yourdomain.com"
        }
      }
    }))
  };

  return (
    <header style={{ minHeight: "100vh", background: "#f8f9fc", width: "100%", overflowX: "hidden" }}>
      
      {/* JSON-LD Script Injection */}
      <script 
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(courseSchema).replace(/</g, '\\u003c') }}
      />

      <style>{`
        @keyframes scroll-left { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
        .marquee-inner { animation: scroll-left 24s linear infinite; }
        .marquee-inner:hover { animation-play-state: paused; }
        @keyframes pulse-dot { 0%, 100% { opacity: 1; transform: scale(1); } 50% { opacity: .5; transform: scale(1.7); } }
        
        .course-card { transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s; }
        .course-card:hover { transform: translateY(-5px) !important; box-shadow: 0 10px 26px rgba(24, 0, 173, 0.15) !important; border-color: #1800ad !important; }
        
        @media (max-width: 768px) {
          .stats-row { grid-template-columns: repeat(2, 1fr) !important; }
        }

        /* ── HERO RESPONSIVE FIX ── */
        .hero-section {
          position: relative;
          height: 80vh;
          min-height: 600px;
          width: 100vw;
          overflow: hidden;
          background-color: #1a1a1a;
          left: calc(-50vw + 50%);
        }
        
        .hero-img {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center center;
          display: block;
          transition: opacity 1.2s ease-in-out;
          z-index: 1;
        }

        .hero-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(to bottom, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.85) 100%);
          z-index: 2;
        }

        @media (max-width: 768px) {
          .hero-section {
            height: 100svh; /* Use full screen height */
            min-height: unset;
            width: 100%;
            left: 0;
          }
          
          .hero-img {
            object-fit: cover; /* Fills screen completely, no black spaces */
            object-position: center 15%; /* Anchors image near the top so faces are never cut off */
          }

          /* Darken bottom gradient slightly on mobile so text stands out over the image */
          .hero-overlay {
            background: linear-gradient(to bottom, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.5) 40%, rgba(0,0,0,0.95) 100%);
          }
        }
      `}</style>

      {/* Top stripe using the new palette */}
      <div style={{ height: 5, background: "linear-gradient(90deg, #d11210, #ffde59, #1800ad)", width: "100%" }} aria-hidden="true" />

      {/* ── HERO BANNER ── */}
      <section aria-label="Hero Banner" className="hero-section">
        
        {/* Auto-changing Images */}
        {HERO_IMAGES.map((imgUrl, index) => (
          <img 
            key={index}
            src={imgUrl} 
            alt={`AnaBel Institute classroom and campus view ${index + 1}`}
            loading={index === 0 ? "eager" : "lazy"}
            fetchPriority={index === 0 ? "high" : "auto"}
            className="hero-img"
            style={{ opacity: currentImageIndex === index ? 1 : 0 }}
          />
        ))}

        {/* Gradient Overlay */}
        <div className="hero-overlay" aria-hidden="true" />
        
        {/* Text Content */}
        <div style={{ position: "absolute", bottom: 40, left: 0, right: 0, textAlign: "center", color: "#fff", padding: "0 20px", zIndex: 3 }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 7, background: "#d11210", color: "#fff", fontSize: 14, fontWeight: 700, padding: "6px 18px", borderRadius: 99, marginBottom: 14, letterSpacing: "0.08em" }}>
            <span style={{ width: 7, height: 7, borderRadius: "50%", background: "#ffde59", display: "inline-block", animation: "pulse-dot 1.5s infinite" }} aria-hidden="true" />
            Admissions Open 2025–26
          </div>
          <h1 style={{ fontSize: "clamp(30px,6vw,48px)", fontWeight: 700, lineHeight: 1.18, textShadow: "0 2px 10px rgba(0,0,0,0.7)", marginBottom: 10 }}>
            India's Most Trusted<br /><span style={{ color: "#ffde59" }}>Vocational Training</span> Institute
          </h1>
          <h2 style={{ fontSize: "clamp(18px,3.5vw,24px)", margin: 0, opacity: 0.93, textShadow: "0 1px 5px rgba(0,0,0,0.5)", marginBottom: 10 }}>
            ನಮ್ಮ ಶಿಕ್ಷಣ, ನಿಮ್ಮ ಭವಿಷ್ಯ — ಶಿಕ್ಷಕರಾಗಿ ಬೆಳೆಯಿರಿ
          </h2>
          <p style={{ fontSize: "clamp(14px,2.5vw,18px)", opacity: 0.82, maxWidth: 620, margin: "0 auto 18px", lineHeight: 1.6 }}>
            Empowering rural youth with quality teacher education since 2007.<br /> Nationally recognized · Job guaranteed training.
          </p>
          <div style={{ display: "inline-block", background: "#ffde59", color: "#1800ad", fontSize: 15, fontWeight: 800, padding: "7px 22px", borderRadius: 8, letterSpacing: "0.05em" }}>
            🏆 100% Placement Assistance
          </div>
        </div>
      </section>

      {/* ── TRUST STRIP ── */}
      <ul aria-label="Institute Accreditations" style={{ background: "#1800ad", display: "flex", justifyContent: "center", flexWrap: "wrap", padding: "12px 16px", margin: 0, listStyle: "none" }}>
        {["20,000+ Partner Schools", "100% Placement Assistance", "Since 2007"].map((item, i, arr) => (
          <li key={item} style={{ display: "flex", alignItems: "center", gap: 6, padding: "4px 18px", borderRight: i < arr.length-1 ? "1px solid rgba(255,255,255,0.2)" : "none", color: "#fff", fontSize: 14, fontWeight: 600 }}>
            <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#ffde59", display: "inline-block" }} aria-hidden="true" />
            {item}
          </li>
        ))}
      </ul>

      {/* ── STATS ── */}
      <section aria-label="Institute Statistics" className="stats-row" style={{ display: "grid", gridTemplateColumns: `repeat(${STATS.length}, 1fr)`, background: "linear-gradient(135deg, #d11210, #a30e0c)", padding: "30px 16px" }}>
        {STATS.map((s, i) => (
          <div key={i} style={{ textAlign: "center", padding: "10px 4px", borderRight: i === STATS.length - 1 ? "none" : "1px solid rgba(255,255,255,0.25)" }}>
            <div style={{ fontSize: "clamp(28px, 6vw, 42px)", fontWeight: 800, color: "#ffde59", lineHeight: 1 }}>
              <CountUp target={s.target} display={s.display} />
            </div>
            <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: "4px" }}>
              <div style={{ fontSize: 12, color: "#fff", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em" }}>{s.label}</div>
              <div style={{ fontSize: 13, color: "rgba(255,255,255,0.8)", fontWeight: 500 }}>ಮಾಹಿತಿ</div>
            </div>
          </div>
        ))}
      </section>

      {/* ── COURSES ── */}
      <section aria-labelledby="courses-heading">
        <h2 id="courses-heading" style={{ textAlign: "center", padding: "40px 16px 10px", fontSize: 30, fontWeight: 700, margin: 0, color: "#1800ad" }}>
          <span style={{ color: "#d11210", borderBottom: "4px solid #ffde59", paddingBottom: 3 }}>Our Courses | ನಮ್ಮ ಕೋರ್ಸ್‌ಗಳು</span>
        </h2>
        <p style={{ textAlign: "center", fontSize: 16, color: "#777", paddingBottom: 30, margin: 0, marginTop: 10 }}>
          Choose your path to become a great teacher | ಶಿಕ್ಷಕರಾಗಲು ನಿಮ್ಮ ದಾರಿಯನ್ನು ಆರಿಸಿ
        </p>

        <div style={{ width: "100%", overflowX: "auto", scrollbarWidth: "none", WebkitOverflowScrolling: "touch" }}>
          <div style={{ display: "flex", gap: 24, padding: "10px 40px 40px", justifyContent: "center", width: "max-content", margin: "0 auto" }}>
            {COURSES.slice(0, 5).map((course, i) => (
              <motion.article
                key={course.title}
                className="course-card"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.08 * i }}
                style={{ width: 260, background: "#fff", borderRadius: 16, overflow: "hidden", border: "2px solid #e1e4f0", boxShadow: "0 6px 15px rgba(0,0,0,0.06)", cursor: "pointer", flexShrink: 0 }}
              >
                <img src={course.img} alt={`Students in ${course.title} program`} loading="lazy" style={{ width: "100%", height: 170, objectFit: "cover", display: "block" }} />
                <div style={{ padding: "18px" }}>
                  <h3 style={{ fontSize: 18, fontWeight: 700, color: "#1800ad", lineHeight: 1.2, marginBottom: 6, marginTop: 0 }}>{course.title}</h3>
                  <div style={{ fontSize: 15, color: "#555", fontWeight: 500, marginBottom: 14 }}>ಕೋರ್ಸ್ ವಿವರಗಳು</div>
                  <div style={{ fontSize: 14, color: "#888", marginBottom: 14 }}>
                    <span style={{ color: "#d11210", fontWeight: 600 }}>{course.students} Joined | ಸೇರಿದವರು</span>
                  </div>
                  <div style={{ background: "#ffde59", color: "#1800ad", fontSize: 12, fontWeight: 800, padding: "5px 12px", borderRadius: 6, display: "inline-block", marginBottom: 18 }}>
                    ⏱ {course.duration}
                  </div>
                  <div style={{ borderTop: "1px solid #F0F0F0", paddingTop: "14px" }}>
                    <a href={`/courses`} aria-label={`Know more about ${course.title}`} style={{ color: "#d11210", textDecoration: "none", fontSize: 15, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      Know More / ತಿಳಿಯಿರಿ <span style={{ color: "#1800ad" }} aria-hidden="true">→</span>
                    </a>
                  </div>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </section>

      {/* ── PLACEMENT HIGHLIGHT ── */}
      <section aria-labelledby="placement-heading" style={{ background: "linear-gradient(135deg, #1800ad, #0e0066)", color: "#fff", padding: "32px 20px", textAlign: "center" }}>
        <h2 id="placement-heading" style={{ fontSize: "clamp(24px,4.5vw,34px)", fontWeight: 800, color: "#ffde59", margin: 0, marginBottom: 10 }}>🏆 100% Placement Assistance</h2>
        <p style={{ fontSize: 16, color: "rgba(255,255,255,0.85)", maxWidth: 600, margin: "0 auto 20px", lineHeight: 1.65 }}>
          Every student who completes our program gets placed in a school. We have strong partnerships with private schools across Karnataka. Our training is designed to make you job-ready from day one.
        </p>
        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 12 }}>
          {PLACEMENT_PILLS.map(pill => (
            <span key={pill} style={{ background: "rgba(255,222,89,0.15)", border: "1.5px solid rgba(255,222,89,0.4)", color: "#ffde59", fontSize: 14, fontWeight: 700, padding: "8px 18px", borderRadius: 99 }}>{pill}</span>
          ))}
        </div>
      </section>

      {/* ── MARQUEE ── */}
      <div aria-hidden="true" style={{ overflow: "hidden", background: "#fff", borderTop: "2px solid #e1e4f0", borderBottom: "2px solid #e1e4f0", padding: "12px 0" }}>
        <div className="marquee-inner" style={{ display: "flex", width: "max-content" }}>
          {[...MARQUEE_ITEMS, ...MARQUEE_ITEMS].map((item, i) => (
            <span key={i} style={{ whiteSpace: "nowrap", padding: "0 30px", fontSize: 13, fontWeight: 700, letterSpacing: "0.15em", textTransform: "uppercase", color: i % 3 === 0 ? "#1800ad" : i % 3 === 1 ? "#d11210" : "#888" }}>
              {item} ◆
            </span>
          ))}
        </div>
      </div>

    </header>
  );
}